import React, { useRef, useState } from 'react';
import Stepper from './Stepper/Stepper';
import AddPropertySection from './addproperty';

const AddPropertyPage = () => {
  const [currentStep, setCurrentStep] = useState(0);

  // Define individual refs for each fieldset
  const basicDetailsRef = useRef(null);
  const locationDetailsRef = useRef(null);
  const propertyProfileRef = useRef(null);
  const mediaRef = useRef(null);
  const amenitiesRef = useRef(null);

  // Scroll to corresponding section based on stepIndex
  const handleStepClick = (stepIndex) => {
    setCurrentStep(stepIndex);
  
    const refs = [
      basicDetailsRef,
      locationDetailsRef,
      propertyProfileRef,
      mediaRef,
      amenitiesRef,
    ];
  
    const selectedRef = refs[stepIndex]?.current;
  
    // Special case: Scroll to top for `basicDetailsRef`
    if (selectedRef === basicDetailsRef.current) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
  
    // General case: Scroll to the selected section with offset adjustment
    if (selectedRef) {
      selectedRef.scrollIntoView({ behavior: 'smooth', block: 'start' });
  
      setTimeout(() => {
        window.scrollBy({ top: -40, behavior: 'smooth' });
      }, 200);
    }
  };
  
  
  return (
    <div className="pt-[140px] pb-[100px] flex bg-[#f5f5f5]">
      {/* Stepper Section */}
      {/* <div className="w-[25%] h-full bg-white sticky top-[100px] overflow-y-hidden">
        <Stepper currentStep={currentStep} onStepClick={handleStepClick} />
      </div> */}

      {/* Add Property Section */}
      {/* <div className="w-[75%]  p-6 bg-gray-50"> */}
        <AddPropertySection
          refs={{
            basicDetailsRef,
            locationDetailsRef,
            propertyProfileRef,
            mediaRef,
            amenitiesRef,
          }}
          setCurrentStep={setCurrentStep}
        />
        
      {/* </div> */}
    </div>
  );
};

export default AddPropertyPage;
